type PaginationFilters = { index?: number | null; size?: number | null };

/** Rows per page every paginated list starts with. */
export const DEFAULT_PAGE_SIZE = 50;

type UseUrlPaginationParams<T extends PaginationFilters> = {
  urlFilters: T;
  updateParams: (params: Partial<T>) => void;
  total?: number;
  /** Value of `index` on the first page: 0 for most endpoints, 1 for a few. */
  indexBase?: 0 | 1;
};

/** Props for `CTableFooter` backed by the `index` / `size` URL params of a list page. */
export const useUrlPagination = <T extends PaginationFilters>({
  urlFilters,
  updateParams,
  total,
  indexBase = 0,
}: UseUrlPaginationParams<T>) => ({
  current: (urlFilters.index ?? indexBase) - indexBase + 1,
  pageSize: urlFilters.size ?? DEFAULT_PAGE_SIZE,
  total: total ?? 0,
  onPageChange: (page: number) =>
    updateParams({ ...urlFilters, index: page - 1 + indexBase } as unknown as Partial<T>),
  onPageSizeChange: (size: number) =>
    updateParams({ ...urlFilters, size, index: indexBase } as unknown as Partial<T>),
});
